const notes = {
  notes: `Notes`,
  note: `Note`,
  no_notes_found: `No notes found`,
  add_a_note: `Add a note`,
  note_is_required: `Note is required`,
  note_validation_max_length: `Note cannot be more than 1000 characters`,
  notes_length_exceed: `Notes length exceeded`,
  delete_note_title: `Delete note`,
  delete_note_confirmation: `Are you sure you want to delete this note? This action cannot be undone.`,
  note_deletedBy_deletedOn: `Deleted by {{deletedBy}} on {{deletedOn}}`,
  document_note_not_owner: `You are not the owner of this note and cannot perform this action.`,
};
export default notes;
